import { selectRefiDetails, selectRefiYearsInHome } from '../../../../store/selectors/refinance'
import { Waypoint } from 'react-waypoint'
import history from '../../../../history'
import RefiHeading from '../../RefiHeading'
import { FormattedMessage } from 'react-intl'
import { RefiOptionReveal } from './RefiOptionReveal'
import { useDispatch, useSelector } from 'react-redux'
import { YearsInHomeSlider } from './YearsInHomeSlider'
import { Heading } from '@homebotapp/hb-react-component-catalog'
import { useState, useCallback, useEffect } from 'react'
import { setYearsInHome } from '../../../../actions/refinance'
import { buildRefiKey } from '../../../../constants/refinance'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import { useTrackingContext } from '../../../../providers/tracking'
import { TrackingEventConstants } from '../../../../constants/tracking'
import { useTrackingDebounceSetters } from '../../../../hooks/tracking'
import { selectRefiStatus } from '../../../../store/selectors/home/interest'
import { RefiDetailsOverlay } from '../../../homeowners/RefiDetailsOverlay/RefiDetailsOverlay'
import { useCreateHomeClientEvent } from '../../../../hooks/useCreateHomeClientEvent'
import { ClientEventName } from '../../../../api/gqlaxy/gql/generated/graphql'

export interface RefiByYearsInHomeProps {
  withCurrentHomeData: boolean
}

export const RefiByYearsInHome = ({ withCurrentHomeData }: RefiByYearsInHomeProps) => {
  const dispatch = useDispatch()
  const yearsInHome = useSelector(selectRefiYearsInHome)
  const [years, setYears] = useState(yearsInHome)
  const { trackingClient } = useTrackingContext()
  const refiStatus = useSelector(selectRefiStatus)
  const [mouseDown, setMouseDown] = useState(false)
  const refiDetails = useSelector(selectRefiDetails)
  const createRefiSliderclientEvent = useCreateHomeClientEvent({ eventName: ClientEventName.RefiSliderInteraction })
  const [trackingYearsInHomeAdjusted, clearDebounceForYearsInHomeAdjusted] = useTrackingDebounceSetters(
    () => trackingClient?.yearsInHomeAdjusted()
  )
  const [trackModuleViewed, clearDebounceForTrackModuleViewed] = useTrackingDebounceSetters(
    () =>
      trackingClient?.moduleViewed({
        module_name: TrackingEventConstants.REFI
      })
  )

  const navRefiOption = opt => {
    const key = buildRefiKey(opt)
    history.push(OVERLAY_HELPERS.refinance.buildPath(key))
  }

  const onSliderChange = useCallback(
    e => {
      setYears(parseInt(e.target.value, 10))
      trackingYearsInHomeAdjusted()
    },
    [setYears, trackingYearsInHomeAdjusted]
  )

  const onSliderBlur = useCallback(() => {
    clearDebounceForYearsInHomeAdjusted()
  }, [clearDebounceForYearsInHomeAdjusted])

  const handleScrollEvent = useCallback(() => {
    trackModuleViewed()
  }, [trackModuleViewed])

  useEffect(() => {
    return () => {
      clearDebounceForTrackModuleViewed()
    }
  }, [clearDebounceForTrackModuleViewed])

  return (
    <>
      <Heading as='h3' variant='eyebrow' textAlign='center' size='sm'>
        <FormattedMessage id='RefiByYearsInHome.subHeading.new' defaultMessage='Rates Based On National Trends' />
      </Heading>
      <RefiHeading isFha={!!refiStatus?.fha} isConsolidation={refiStatus?.isConsolidation} />
      <Waypoint onEnter={handleScrollEvent} bottomOffset='50%' />
      <YearsInHomeSlider
        min='1'
        max='30'
        onBlur={onSliderBlur}
        onChange={onSliderChange}
        onTouchMove={onSliderChange}
        onMouseDown={() => setMouseDown(true)}
        onTouchStart={() => setMouseDown(true)}
        value={mouseDown ? years : yearsInHome}
        onMouseUp={() => {
          setMouseDown(false)
          createRefiSliderclientEvent()
          dispatch(setYearsInHome(years))
        }}
        onTouchEnd={() => {
          setMouseDown(false)
          createRefiSliderclientEvent()
          dispatch(setYearsInHome(years))
        }}
      />
      {refiDetails && <RefiDetailsOverlay options={refiDetails} />}
      <RefiOptionReveal
        options={refiDetails}
        yearsInHome={yearsInHome}
        onClickOption={navRefiOption}
        locked={!withCurrentHomeData}
      />
    </>
  )
}
